import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Native select, GRYD dressed.
 *
 * @param {object} p
 * @param {string} [p.value]
 * @param {(v: string) => void} [p.onChange]
 * @param {Array<string|{ value: string; label: React.ReactNode }>} p.options
 * @param {string} [p.placeholder]
 * @param {'sm'|'md'} [p.size]
 * @param {boolean} [p.invalid]
 * @param {boolean} [p.disabled]
 * @param {React.CSSProperties} [p.style]
 */
export function Select({ value, onChange, options = [], size = 'md', invalid, disabled, placeholder, style, ...rest }) {
  const H = size === 'sm' ? 'var(--ctl-h-sm)' : 'var(--ctl-h)';
  return h('span', { style: { position: 'relative', display: 'block', ...style } },
    h('select', { value, disabled, 'aria-invalid': invalid || undefined, onChange: (e) => onChange && onChange(e.target.value), ...rest, className: 'gx-input',
      style: { width: '100%', height: H, boxSizing: 'border-box', padding: '0 34px 0 12px', appearance: 'none', WebkitAppearance: 'none', fontFamily: BODY, fontSize: size === 'sm' ? 12.5 : 13.5, fontWeight: 600, color: value ? 'var(--tx)' : 'var(--mut2)', background: 'var(--input)', border: `2px solid ${invalid ? 'var(--coral)' : 'var(--ink)'}`, borderRadius: size === 'sm' ? 8 : 10, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .55 : 1 } },
      placeholder ? h('option', { value: '', disabled: true }, placeholder) : null,
      options.map((o) => { const v = typeof o === 'string' ? o : o.value, l = typeof o === 'string' ? o : o.label; return h('option', { key: v, value: v }, l); })),
    h('span', { 'aria-hidden': true, style: { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', display: 'flex', color: 'var(--tx)' } }, h(Icon, { name: 'chevron-down', size: 16 })));
}
